import {
	GET_ACCESS,
	GET_ACCESS_ERROR,
	GET_ACCESS_SUCCESS,
} from '../../constants';

export const getAccessReducer = (state, actions) => {
	switch (actions.type) {
		case GET_ACCESS:
			return {
				...state,
				loading: true,
				error: null,
				errorShow: false,
			};
		case GET_ACCESS_ERROR:
			return {
				...state,
				loading: false,
				error: actions.payload,
				errorShow: true,
			};
		case GET_ACCESS_SUCCESS:
			return {
				...state,
				loading: false,
				error: null,
				errorShow: false,
				access: actions.payload,
			};
		default:
			return state;
	}
};
